import { render, staticRenderFns } from "./ModalSlotAttributes.vue?vue&type=template&id=a802c2a8"
import script from "./ModalSlotAttributes.vue?vue&type=script&lang=js"
export * from "./ModalSlotAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports